
        import * as module0 from './controllers/menu_controller.js'
        const modules = {
            "./controllers/menu_controller.js": module0,
        };
        export default modules;
      